module.exports = __webpack_public_path__ + "static/img/iv_no_data.fc46269.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/personal/iv_no_data.png
// module id = op5/
// module chunks = 1